import React, { Component } from 'react';
import '../../css/pages/agents.css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import undrawLoading from '../../assets/svgs/undraw_Loading_re_5axr.svg';
import undrawSearch from '../../assets/svgs/undraw_search_re_ttoj.svg';
import SideNav from '../components/SideNav';
import TopNav from '../components/TopNav';
import { fetchValidations } from '../actions/account';
import Pagination from '../components/Pagination';

class Validations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validations: [],
      current_page: new URLSearchParams(props.location.search).get('page') || 1,
      limit: 10,
    };
  }

  handlePageChange = (data) => {
    const { limit } = this.state;
    fetchValidations(data.currentPage, '', 'created_on', 'DESC', limit)
      .then(({ data: { validations, page_info } }) => this.setState({
        validations,
        current_page: page_info.page,
        total: page_info.total,
      }));
  };

  onSearch = (e) => {
    const { limit } = this.state;
    fetchValidations(e.currentPage, e.currentTarget.value, 'created_on', 'DESC', limit)
      .then(({ data: { validations, page_info } }) => this.setState({
        validations,
        current_page: page_info.page,
        total: page_info.total,
      }));
  }

  render() {
    const {
      validations, total, current_page, limit,
    } = this.state;
    const { history } = this.props;
    return (
      <>
        <SideNav page="validations" />
        <main className="body-main">
          <div className="body-main__container">
            <TopNav page="validations" />
            <section className="body-main__content">
              <div className="agents">
                <div className="pageTitle d-lg-none">
                  <h3 className="pageTitle__header">Validations</h3>
                </div>

                <div className="row">
                  <div className="col">
                    <div className="empty-state agents__empty-state" hidden={validations.length}>
                      <img src={undrawLoading} alt="Illustration for empty state" />
                      <h3 className="empty-state__title">
                        There is nobody here.
                      </h3>
                      <p className="empty-state__subtext">
                        Validations will show up here.
                      </p>
                    </div>
                    <div className="filled--state agents" hidden={!validations.length}>
                      <div className="filter-and-search">
                        <div className="filter-box d-flex">
                          {/* <div className="input-group input-group-filter">
                            <div className="input-group-prepend">
                              <span className="input-group-text">Date:</span>
                            </div>
                            <input type="date" className="form-control" />
                          </div> */}
                          <div className="search-box">
                            <input
                              type="search"
                              className="form-control"
                              placeholder="Search..."
                              onInput={(e) => e.currentTarget.value === '' && this.onSearch(e)}
                              onKeyDown={(e) => e.key === 'Enter' && this.onSearch(e)} />
                          </div>
                        </div>
                        <div className="button-box">

                        </div>
                      </div>
                      <div className="row">
                        <div className="col">
                          <div className="card default-card page-table">
                            <div className="empty-state no-result" hidden>
                              <img src={undrawSearch} alt="Illustration for search" />
                              <h3 className="empty-state__title">
                                No results found.
                              </h3>
                              <p className="empty-state__subtext">
                                Please check your spelling or try searching for something different.
                              </p>
                            </div>

                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th className="uuid">UUID</th>
                                    <th className="ip">IP</th>
                                    <th className="match">Match Status</th>
                                    <th className="charge">Charge</th>
                                    <th className="payment">Payment Status</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {validations.map((log) => (
                                    <tr key={log.id}>
                                      <td className="uuid text-nowrap">
                                        {log?.uuid}
                                      </td>
                                      <td className="ip text-nowrap">{log?.ip}</td>
                                      <td className="match text-nowrap">{log?.response?.img_matches ? 'success' : 'failed'}</td>
                                      <td className="charge text-nowrap">{Number(log.charge || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                      <td className="payment_status text-nowrap">{log?.payment_status}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <Pagination
                            totalRecords={total}
                            pageLimit={limit}
                            pageNeighbours={1}
                            onPageChanged={this.handlePageChange}
                            initialPage={current_page} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
      </>
    );
  }
}

export default Validations;
